// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x1pf","content":"styles_content__HxDy4"};